import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { EnquiryDialog } from "../components/EnquiryDialog";
import { TESTIMONIALS, IMAGES } from "../data/site";
import { Star, Quote } from "lucide-react";

export default function Reviews() {
  return (
    <div data-testid="reviews-page">
      <PageHero eyebrow="Reviews · Google Reviews" title={["Trusted by 500+", "happy travellers."]}
        subtitle="Real words from real families, couples and groups who explored Kerala with us." image={IMAGES.kathakali} />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-24">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-16">
            <div className="flex gap-1 mb-3">{[...Array(5)].map((_, i) => <Star key={i} className="w-7 h-7 fill-gold text-gold" />)}</div>
            <p className="font-serif text-5xl text-emerald">4.9<span className="text-2xl text-ink/40"> / 5</span></p>
            <p className="text-ink/50 mt-2">Based on 500+ verified journeys</p>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div className="border border-emerald/10 p-8 h-full bg-white hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5 transition-all duration-300" data-testid={`review-${i}`}>
                <Quote className="w-8 h-8 text-gold/40" />
                <div className="flex my-4">{[...Array(t.rating)].map((_, s) => <Star key={s} className="w-4 h-4 fill-gold text-gold" />)}</div>
                <p className="text-ink/80 font-serif text-lg italic leading-relaxed">“{t.text}”</p>
                <div className="mt-6 pt-4 border-t border-emerald/10">
                  <p className="font-semibold text-emerald">{t.name}</p>
                  <p className="text-ink/50 text-xs mt-0.5">{t.from} · {t.type}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div className="mt-20 text-center">
            <h2 className="font-serif text-3xl lg:text-4xl font-light text-emerald mb-6">Ready to write your own story?</h2>
            <EnquiryDialog title="Get a Free Quote" trigger={
              <button className="bg-emerald text-cream px-10 py-4 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors" data-testid="reviews-cta-btn">Start Planning</button>
            } />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
